import React, { useState } from "react";
import ManagementHeader from "../components/common-managment/ManagementHeader";
import user from "../../src/assets/icons/user-white.svg";
import add from "../assets/icons/add.svg";
import remove from "../assets/icons/delete.svg";
import TableData from "../components/user-management/TableData";
import toast from "react-hot-toast";

export default function UserManagement() {
  const [addRowForm, setAddRowForm] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [newData, setNewData] = useState({
    name: "Manager1",
    authority: "Manager",
    memo: "마스터 계정",
  });
  const [rows, setRows] = useState([
    {
      name: "Manager1",
      authority: "Manager",
      memo: "마스터 계정",
    },
    {
      name: "Manager2",
      authority: "Manager",
      memo: "마스터 계정",
    },
    {
      name: "Manager3",
      authority: "Manager",
      memo: "마스터 계정",
    },
    {
      name: "Manager4",
      authority: "Manager",
      memo: "마스터 계정",
    },
    {
      name: "Manager5",
      authority: "Manager",
      memo: "마스터 계정",
    },
    {
      name: "Manager6",
      authority: "Manager",
      memo: "마스터 계정",
    },
    {
      name: "Manager1",
      authority: "Manager",
      memo: "마스터 계정",
    },
    {
      name: "Manager2",
      authority: "Manager",
      memo: "마스터 계정",
    },
    {
      name: "Manager3",
      authority: "Manager",
      memo: "마스터 계정",
    },
    {
      name: "Manager4",
      authority: "Manager",
      memo: "마스터 계정",
    },
    {
      name: "Manager5",
      authority: "Manager",
      memo: "마스터 계정",
    },
    {
      name: "Manager6",
      authority: "Manager",
      memo: "마스터 계정",
    },
    {
      name: "Manager1",
      authority: "Manager",
      memo: "마스터 계정",
    },
    {
      name: "Manager2",
      authority: "Manager",
      memo: "마스터 계정",
    },
    {
      name: "Manager3",
      authority: "Manager",
      memo: "마스터 계정",
    },
    {
      name: "Manager4",
      authority: "Manager",
      memo: "마스터 계정",
    },
    {
      name: "Manager5",
      authority: "Manager",
      memo: "마스터 계정",
    },
    {
      name: "Manager6",
      authority: "Manager",
      memo: "마스터 계정",
    },
  ]);

  // ✅ handle save
  const handleSave = () => {
    setRows((prev) => [...prev, { ...newData }]);
    toast.success("User saved successfully!");
    setAddRowForm(false);
  };

  const handleSelectedRowsDelete = () => {
    // remove selected rows
    setRows((prev) => prev.filter((_, idx) => !selectedRows.includes(idx)));
    setSelectedRows([]); // clear selection
    toast.success("User Delete successfully!");
  };

  return (
    <main className="bg-[#262d44] !pt-0 p-4 sm:p-[30px] flex flex-col h-screen">
      <ManagementHeader />
      <div className="flex-1 bg-[#323649] rounded-[10px] md:rounded-[16px] overflow-hidden flex flex-col">
        {/* top bar  */}
        <div className="bg-[#44495F] sm:py-2 px-4 sm:pr-2.5 py-4 flex items-center flex-wrap gap-4 justify-between shadow-[0_20px_40px_0_rgba(15,_17,_26,_0.20)] ">
          {/* left side  */}
          <div className="flex items-center gap-2.5">
            <img src={user} alt="" />
            <h4 className="text-white font-medium text-[18px]">사용자 관리</h4>
          </div>

          {/* right side  */}
          <div className="flex items-center gap-2.5">
            <button
              onClick={() => setAddRowForm(true)}
              className="p-2.5 bg-[#232633] rounded-[6px] w-[75px] h-8 flex items-center justify-center"
            >
              <img src={add} alt="" />
            </button>
            <button
              onClick={handleSelectedRowsDelete}
              className="p-2.5 bg-[#232633] rounded-[6px] w-[75px] h-8 flex items-center justify-center disabled:cursor-not-allowed"
              disabled={selectedRows.length === 0}
            >
              <img src={remove} alt="" />
            </button>
          </div>
        </div>

        {/* table data  */}
        <TableData
          rows={rows}
          setRows={setRows}
          newData={newData}
          setNewData={setNewData}
          handleSave={handleSave}
          addRowForm={addRowForm}
          setAddRowForm={setAddRowForm}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
        />
      </div>
    </main>
  );
}
